<template>
  <div class="my-5">
    <h3 class="blue-text">{{L10n('manually')}}</h3>
    <form-add
      :model="getModel"
      :data="dataForm"
      :disabled="disabled"
      @onAddToQuote="handlerAddToQuote"
    ></form-add>
  </div>
</template>
<script>
import { ModelRFQ1 } from '../../models'
export default {
  name: 'Manually',
  components: {
    'form-add': () => import(/* webpackChunkName: 'QuickRFQPart' */ './Form.vue')
  },
  props: {
    partID: { type: Number },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    dataForm () {
      return {
        ...ModelRFQ1(),
        partID: this.partID
      }
    }
  },
  methods: {
    handlerAddToQuote (data) {
      this.$emit('onAddQuote', { ...data })
    },
    getModel () {
      return ModelRFQ1()
    }
  }
}
</script>
